import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedTitle } from '!views/Market/StockExchange/marketStockExchange.seletors';
import { uuidSelector } from '»components/Auth';

import { trlDetailsServices } from './trlDetails.services';
import {
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableRowStyled,
  Tables,
  TableStyled,
  Wraper,
} from './TrlDetails.styles';

export const LastTrades = () => {
  const base = {
    entryTime1: '00:00:00',
    entryTime2: '00:00:00',
    entryTime3: '00:00:00',
    entryTime4: '00:00:00',
    entryTime5: '00:00:00',
    entryPx5: 0,
    entrySize1: 0,
    entrySize2: 0,
    entrySize3: 0,
    entrySize4: 0,
    entryPx4: 0,
    entryPx3: 0,
    entryPx2: 0,
    entryPx1: 0,
    entrySize5: 0,
  };
  const [tradeData, setTradeData] = useState(base);

  const selectedTitle = useSelector(getSelectedTitle);
  const uuid = useSelector(uuidSelector);

  const callService = async (a, b, c) => {
    const response = await trlDetailsServices.lastTradeService({
      symbol: a,
      exchange: b,
      securityType: c,
    });
    response.map((el) => {
      setTradeData(el);
      return el;
    });
  };

  const selectedTitleExists = Object.keys(selectedTitle).length > 0;

  useEffect(() => {
    if (selectedTitleExists)
      callService(
        selectedTitle.symbol,
        selectedTitle.exchange,
        selectedTitle.securityType,
      );
  }, [
    selectedTitle.symbol,
    selectedTitle.exchange,
    selectedTitle.securityType,
    selectedTitleExists,
    uuid,
  ]);

  return (
    <Wraper>
      <Tables>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-HOUR" />
              </TableCellStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-PRICE" />
              </TableCellStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-QUANTITY" />
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled maxHeight="100%">
            <TableRowStyled>
              <TableCellStyled>{tradeData.entryTime1}</TableCellStyled>
              <TableCellStyled>{tradeData.entryPx1}</TableCellStyled>
              <TableCellStyled>{tradeData.entrySize1}</TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>{tradeData.entryTime2}</TableCellStyled>
              <TableCellStyled>{tradeData.entryPx2}</TableCellStyled>
              <TableCellStyled>{tradeData.entrySize2}</TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>{tradeData.entryTime3}</TableCellStyled>
              <TableCellStyled>{tradeData.entryPx3}</TableCellStyled>
              <TableCellStyled>{tradeData.entrySize3}</TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>{tradeData.entryTime4}</TableCellStyled>
              <TableCellStyled>{tradeData.entryPx4}</TableCellStyled>
              <TableCellStyled>{tradeData.entrySize4}</TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>{tradeData.entryTime5}</TableCellStyled>
              <TableCellStyled>{tradeData.entryPx5}</TableCellStyled>
              <TableCellStyled>{tradeData.entrySize5}</TableCellStyled>
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </Tables>
    </Wraper>
  );
};
